<template>
  <section class="token-security-panel">
    <div class="tsp-body hidden-scrollbar">
      <div class="tsp-section--details">
        <div class="tsp-section-tax">
          <div class="tsp-section-title">
            {{ $t('tokenSecurityData.taxRate') }}
          </div>

          <TokenSecurityTaxCard
            :isSol="isSol"
            :queryIcon="queryIcon"
            :goPlusIcon="goPlusIcon"
            :certikIcon="certikIcon"
            :goPlusTax="goPlusTax"
            :certikTax="certikTax"
            :goPlusBuyTaxColor="goPlusBuyTaxColor"
            :goPlusSellTaxColor="goPlusSellTaxColor"
            :certikBuyTaxColor="certikBuyTaxColor"
            :certikSellTaxColor="certikSellTaxColor"
            :showGoPlus="showGoPlus"
            :showCertik="showCertik"
          />
        </div>

        <TokenSecurityChecks :securityList="securityList" :isSol="isSol" :epoch="epoch" :showGoPlus="showGoPlus" :showCertik="showCertik" />
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import TokenSecurityChecks from './TokenSecurityChecks.vue';
import TokenSecurityTaxCard from './TokenSecurityTaxCard.vue';
export default {
  name: 'TokenSecurityPanel',
  components: {
    TokenSecurityChecks,
    TokenSecurityTaxCard,
  },
  props: {
    risky: {
      type: Number,
    },
    attention: {
      type: Number,
    },
    goPlusTax: {
      type: Object,
      default: () => ({}),
    },
    certikTax: {
      type: Object,
      default: () => ({}),
    },
    securityList: {
      type: Array,
      default: () => [],
    },
    isSol: {
      type: Boolean,
    },
    epoch: {
      type: Number,
    },
    goPlusSellTaxColor: {
      type: String,
    },
    goPlusBuyTaxColor: {
      type: String,
    },
    certikSellTaxColor: {
      type: String,
    },
    certikBuyTaxColor: {
      type: String,
    },
    showGoPlus: {
      type: Boolean,
      default: true,
    },
    showCertik: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      taxes: { buy: 99, sell: 1 },
    };
  },
  computed: {
    ...mapGetters(['isMobileSize']),

    queryIcon() {
      return require(`@/assets/token-security/query${this.darkModeImg}.png`);
    },
    goPlusIcon() {
      return require(`@/assets/token-security/go+.png`);
    },
    certikIcon() {
      return require(`@/assets/token-security/Certik.png`);
    },
    errorIcon() {
      return require(`@/assets/token-security/error-red.png`);
    },
    warningIcon() {
      return require(`@/assets/token-security/warning.png`);
    },
  },

  // watch: {
  //   isOpen: {
  //     immediate: true,
  //     handler(newVal) {
  //       if (newVal) {
  //         this.tradeList = [];
  //         this.contractList = [];
  //         this.taxList = [];
  //         this.tokenAnalysis = [];
  //         this.showCount = 1000;
  //         const { base_token: address, blockchain_id } = this.token;
  //         this.getTokenSecurity(address, blockchain_id).then(data => {
  //           if (data) {
  //             console.log("data", data);
  //             if (blockchain_id === 27) {
  //               this.formatSolData(data);
  //             } else {
  //               this.formatEvmData(data);
  //             }
  //           }
  //         });
  //       }
  //     },
  //   },
  // },
};
</script>

<style scoped lang="scss">
.token-security-panel {
  margin-top: 20px;
  background: var(--bg-14);
  // border: 1px solid var(--border-1);
  border-radius: 12px;
  box-shadow: 0 0 20px 0px rgba(0, 0, 0, 0.05);
  padding: 20px 16px;
  display: flex;
  flex-direction: column;
  // height: calc(100vh - 40px);

  .tsp-section-title {
    font-size: 18px;
    font-weight: 500;
    color: var(--color-29);
  }

  .tsp-body {
    flex: 1 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: auto;
  }

  .tsp-section--details {
    // flex: 1 1;
    // min-height: 0;
    // overflow: auto;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
}

@media screen and (max-width: 767px) {
  .token-security-panel {
    margin: 10px 16px 0;
    padding: 16px;
    border-radius: 8px;

    .tsp-section-title {
      font-size: 14px;
    }

    .tsp-section--details {
      gap: 16px;
    }
  }
}
</style>
